import { useCallback, useRef } from "react";
import type { Toast } from "primereact/toast";
import type { ToastMessage } from "./toast";

export function useToast() {
  const toastRef = useRef<Toast>(null);

  const showToast = useCallback((message: ToastMessage) => {
    toastRef.current?.show(message);
  }, []);

  return { toastRef, showToast };
}








